/*
検索条件インターフェース
*/
class SearchConditionInterface {

  private buttonResetEl:HTMLElement;
  private buttonAllEl:HTMLElement;
  private inputEls:NodeListOf<HTMLInputElement>;

  constructor() {

    this.buttonResetEl = document.querySelector('.search__condition-interface-btn--reset');
    this.buttonAllEl = document.querySelector('.search__condition-interface-btn--all');
    this.inputEls = document.querySelectorAll('.search__condition-interface-input');

    this.init();
  }

  init() {
    if (this.buttonResetEl) {
      this.buttonResetEl.addEventListener('click', this.onButtonResetClick.bind(this));
    }
    if (this.buttonAllEl) {
      this.buttonAllEl.addEventListener('click', this.onButtonAllClick.bind(this));
    }
  }

  onButtonResetClick() {
    this.inputEls.forEach(inputEl => {
      inputEl.checked = false;
    });
  }

  onButtonAllClick() {
    this.inputEls.forEach(inputEl => {
      inputEl.checked = true;
    });
  }

  reset() {
    this.inputEls.forEach(inputEl => {
      inputEl.checked = false;
    });
  }
}

export default SearchConditionInterface;

